module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "logical-statement-main"
    }
  }, [(!_vm.list.flgEdit) ? _c('list-view', {
    attrs: {
      "totalLists": _vm.totalLists,
      "list": _vm.list,
      "index": _vm.index,
      "linkList": _vm.linkList,
      "unlinkList": _vm.unlinkList,
      "ungroupList": _vm.ungroupList,
      "editList": _vm.editList,
      "deleteList": _vm.deleteList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.list.flgEdit) ? _c('list-edit', {
    attrs: {
      "nowLang": _vm.nowLang,
      "labelCodsex": _vm.labelCodsex,
      "list": _vm.list,
      "index": _vm.index,
      "setDescConjAndDescStmt": _vm.setDescConjAndDescStmt,
      "viewList": _vm.viewList,
      "findValueType": _vm.findValueType,
      "findInputType": _vm.findInputType,
      "findLovType": _vm.findLovType,
      "listFields": _vm.listFields,
      "listConjunctions": _vm.listConjunctions,
      "listOperators": _vm.listOperators
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4807e809!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsLogicalStatement/listMain.vue
// module id = 3729
// module chunks = 1